import api from '@/lib/api';

export interface SearchResults {
  guests: Array<{ id: string; fullName: string; email: string | null; phone: string | null }>;
  bookings: Array<{
    id: string;
    status: string;
    checkIn: string;
    checkOut: string;
    guest?: { fullName: string } | null;
    unit?: { name: string } | null;
  }>;
  units: Array<{ id: string; name: string; type: string; propertyId: string }>;
  companies: Array<{ id: string; name: string; accountCode: string }>;
}

export async function globalSearch(q: string): Promise<SearchResults> {
  const { data } = await api.get<SearchResults>('/search', { params: { q } });
  return data;
}
